import { Fragment } from 'react'
import ZoomAppRemovePage from '../../../../../assets/images/zoom-integration-remove-1024w.webp'

export const ZoomHowItWorks: React.FC = () => {
  return (
    <Fragment>
      <div>
        <p>
          Zocks' Zoom integration allows you to have your Zocks AI Notetaker with you on your Zoom meetings so that you can focus on your client while Zocks
          captures accurate, actionable, and 100% recording-free notes, so you never miss a detail.
        </p>
        <p>
          With our native Zoom plugin you can access meeting prep materials, real-time client insights, and task management live during your meeting, without
          ever leaving Zoom.
        </p>
      </div>
      <h4 className='mt-5 mb-3'>Before you connect</h4>
      <div>
        <p>
          Zocks connects to whichever Zoom account you're currently signed into in your browser. If you have multiple Zoom accounts, you'll be asked to choose
          one when connecting.
        </p>
        <p>To connect the right account, sign out of Zoom in your browser first. Sign back in with the account you want to use, then return here to connect.</p>
      </div>
      <h4 className='mt-5 mb-3'>Wrong Zoom account connected?</h4>
      <div>
        <p>
          If you connected the wrong Zoom account, you can remove the Zocks app from Zoom's App Marketplace. Go to your installed apps, remove Zocks Meeting,
          then sign back in to Zoom with the correct account and reconnect here.
        </p>
        <p>
          Manage your installed Zoom apps at{' '}
          <a href='https://marketplace.zoom.us/user/installed' target='_blank' rel='noopener noreferrer'>
            marketplace.zoom.us/user/installed
          </a>
          .
        </p>
        <img src={ZoomAppRemovePage} alt='Zoom App Remove Page' className='mw-100' />
      </div>
    </Fragment>
  )
}
